import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@fluentui/react-components";
import { ArrowClockwiseFilled } from "@fluentui/react-icons";
import { useInsurerReportsStore } from "store/InsurerReportsStore";
import { useAppStoreState } from "store/AppStore";

export const RefreshButton = () => {
  const [{ insurerReportsLoadStatus }, { loadInsurerReports }] =
    useInsurerReportsStore();
  const { updatedGrecoCompanies, taxonomy, grecoCompanies } =
    useAppStoreState();
  const { t } = useTranslation();

  return (
    <Button
      data-help="insurer-reports-refresh"
      disabled={insurerReportsLoadStatus === "loading"}
      appearance="subtle"
      icon={<ArrowClockwiseFilled fontSize={24} />}
      onClick={() => {
        loadInsurerReports({
          updatedGrecoCompanies,
          taxonomy,
          grecoCompanies,
          t,
        });
      }}
    ></Button>
  );
};
